import permissions from '../permissions'

const PRIVACY_BY_DESIGN_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.PRIVACY_BY_DESIGN.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.PRIVACY_BY_DESIGN.MANAGE,
  },
  {
    name: 'Gerenciar link externo',
    tag: permissions.PRIVACY_BY_DESIGN.MANAGE_GUEST_PORTAL,
    description:
      'Concede acesso à configuração do link externo (portal de visitantes) do Privacy By Design.',
  },
]

export default PRIVACY_BY_DESIGN_LIST
